import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import Layout from '@/layout'
import Login from '@/views/login'
import Index from '@/views/index'
export const constantRoutes = [
  {
    path: '/login',
    // component: () => import('@/views/login'),
    // 密码+验证码登录页面
    component: () => import('@/views/v2login'),
    // component: Login,
    hidden: true,
    noNeedAuth: true,
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/403'),
    hidden: true,
    noNeedAuth: true,
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true,
    noNeedAuth: true,
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/test'),
    hidden: true,
    noNeedAuth: true,
  },
]
export const asyncRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    meta: {
      title: '首页',
      icon: 'home-4-line',
      affix: true,
    },
    children: [
      {
        path: 'index',
        name: 'home',
        component: () => import('@/views/index'),
        // component: () => Index,
        meta: {
          title: '首页',
          icon: 'home-4-line',
          affix: true,
        },
      },
      {
        path: '/userProfile',
        name: 'userProfile',
        component: () => import('@/views/system_manage/user_profile'),
        hidden: true,
        meta: {
          title: '个人中心',
          icon: 'stackshare-line',
          // affix: true,
        },
      },
    ],
  },
  {
    path: '/personApplication',
    name: 'personApplyManage',
    component: Layout,
    redirect: '/personApplication/person_application',
    alwaysShow: true,
    meta: {
      title: '人员预约申请',
      icon: 'user-line',
      keepAlive: true,
    },
    children: [
      {
        path: 'personApplication',
        name: 'personApply',
        component: () =>
          import('@/views/person_application/person_application'),
        meta: {
          title: '园区企业预约申请',
          icon: 'file-add-line',
          keepAlive: true,
        },
      },
      {
        path: 'personApplicationApproval',
        name: 'personApplyApproval',
        component: () =>
          import('@/views/person_application/person_application_approval'),
        meta: {
          title: '人员预约申请审核',
          icon: 'list-check',
          keepAlive: true,
        },
      },
      {
        path: 'personShddFinalCheck',
        name: 'personShddFinalCheck',
        component: () =>
          import('@/views/person_application/person_shddfinal_approval'),
        meta: {
          title: '石化大队终审审批',
          icon: 'list-check',
          keepAlive: true,
        },
      },
      {
        path: 'person_batch_application',
        name: 'personBatchApply',
        component: () =>
          import('@/views/person_application/person_batch_application'),
        meta: {
          title: '批量导入预约申请',
          icon: 'file-add-line',
        },
      },
      {
        path: 'personApplicationHistory',
        name: 'personApplyHistory',
        component: () =>
          import('@/views/person_application/person_application_history'),
        meta: {
          title: '人员预约申请记录',
          icon: 'file-search-line',
        },
      },
      {
        path: 'allPersonApplicationHistory',
        name: 'allPersonApplyHistory',
        component: () =>
          import('@/views/person_application/all_person_application_history'),
        meta: {
          title: '人员预约信息管理',
          icon: 'file-search-line',
        },
      },
    ],
  },
  {
    path: '/carApplication',
    name: 'carApplyManage',
    component: Layout,
    redirect: '/carApplication/enterpriseApplication',
    alwaysShow: true,
    meta: {
      title: '车辆预约申请',
      icon: 'car-line',
    },
    children: [
      {
        path: 'enterpriseApplication',
        name: 'carApply',
        component: () =>
          import('@/views/car_application/enterprise_application'),
        meta: {
          title: '园区企业预约申请',
          icon: 'file-add-line',
        },
      },
      {
        path: 'carApplicationApproval',
        name: 'carApplyApproval',
        component: () =>
          import('@/views/car_application/car_application_approval'),
          meta: {
            title: '普通车辆预约审核',
            icon: 'list-check',
          },
      },
      {
        path: 'chemicalsCarApproval',
        name: 'chemicalsCarApproval',
        component: () =>
          import('@/views/car_application/car_hazardous_application_approval'),
          meta: {
            title: '危化品车辆预约审核',
            icon: 'list-check',
          },
      },
      {
        path: 'heavytipperApproval',
        name: 'heavytipperApproval',
        component: () =>
          import('@/views/car_application/car_heavytipper_approval'),
        meta: {
          title: '泥头车(自卸货车)审核',
          icon: 'list-check',
        },
      },
      {
        path: 'mediumlargeApproval',
        name: 'mediumlargeApproval',
        component: () =>
          import('@/views/car_application/car_mediumlarge_approval'),
        meta: {
          title: '中大型客车审核',
          icon: 'list-check',
        },
      },
      {
        path: 'carShddFinalCheck',
        name: 'carShddFinalCheck',
        component: () =>
          import('@/views/car_application/car_shddfinal_approval'),
        meta: {
          title: '石化大队终审审批',
          icon: 'list-check',
        },
      },
      {
        path: 'carApplicationHistory',
        name: 'carApplyHistory',
        component: () =>
          import('@/views/car_application/car_application_history'),
        meta: {
          title: '车辆预约申请记录',
          icon: 'file-search-line',
        },
      },
      {
        path: 'allCarApplicationHistory',
        name: 'allCarApplyHistory',
        component: () =>
          import('@/views/car_application/all_car_application_history'),
        meta: {
          title: '车辆预约信息管理',
          icon: 'file-search-line',
        },
      },
      {
        path: 'carRegistration',
        name: 'carRegistration',
        component: () => import('@/views/car_application/car_registration'),
        meta: {
          title: '车辆备案',
          icon: 'file-add-line',
        },
      },
      {
        path: 'carRegistrationApproval',
        name: 'carRegistrationApproval',
        component: () =>
          import('@/views/car_application/car_registration_approval'),
        meta: {
          title: '车辆备案审核',
          icon: 'list-check',
        },
      },
      {
        path: 'carRegistrationHistory',
        name: 'carRegistrationHistory',
        component: () =>
          import('@/views/car_application/car_registration_history'),
        meta: {
          title: '车辆备案记录',
          icon: 'file-search-line',
        },
      },
      {
        path: 'carMark',
        name: 'carMark',
        component: () => import('@/views/car_application/car_mark'),
        meta: {
          title: '车辆标记管理',
          icon: 'file-list-line',
        },
      },
    ],
  },
  {
    path: '/transport',
    name: 'transportList',
    component: Layout,
    redirect: '/transport/transportListApproval',
    alwaysShow: true,
    meta: {
      title: '危险货物运输运单',
      icon: 'menu-line',
    },
    children: [
      {
        path: 'transportListApproval',
        name: 'transportListApproval',
        component: () => import('@/views/transport/transport_approval'),
        meta: {
          title: '运单审核',
          icon: 'list-check',
        },
      },
      {
        path: 'transportListHis',
        name: 'transportListHis',
        component: () => import('@/views/transport/transport_history'),
        meta: {
          title: '运单申请记录',
          icon: 'file-search-line',
        },
      },
      {
        path: 'allTransportListHis',
        name: 'allTransportListHis',
        component: () => import('@/views/transport/all_transport_history'),
        meta: {
          title: '运单信息管理',
          icon: 'file-search-line',
        },
      },
    ],
  },
  {
    path: '/stranded_management',
    name: 'strandedManagement',
    component: Layout,
    redirect: '/stranded_management/person',
    alwaysShow: true,
    meta: {
      title: '滞留管理',
      icon: 'menu-line',
    },
    children: [
      {
        path: 'person',
        name: 'strandedManagementPerson',
        component: () => import('@/views/stranded_management/person'),
        meta: {
          title: '人员滞留',
          icon: 'file-list-line',
        },
      },
      {
        path: 'car',
        name: 'strandedManagementCar',
        component: () => import('@/views/stranded_management/car'),
        meta: {
          title: '车辆滞留',
          icon: 'file-list-line',
        },
      },
    ],
  },
  {
    path: '/equipmentManagement',
    name: 'equipmentManagement',
    component: Layout,
    redirect: '/equipmentManagement/carFace',
    alwaysShow: true,
    meta: {
      title: '设备管理',
      icon: 'device-line',
    },
    children: [
      {
        path: 'carFace',
        name: 'carFaceDevice',
        component: () => import('@/views/equipment_management/car_face'),
        meta: {
          title: '车载人脸识别设备',
          icon: 'file-list-line',
        },
      },
      {
        path: 'securityLaneIdentification',
        name: 'securityLaneIDevice',
        component: () =>
          import('@/views/equipment_management/security_lane_identification'),
        meta: {
          title: '安检车道识别设备',
          icon: 'file-list-line',
        },
      },
      {
        path: 'carScaleSystem',
        name: 'carScaleSystemDevice',
        component: () =>
          import('@/views/equipment_management/car_scale_system'),
        meta: {
          title: '汽车衡系统设备',
          icon: 'file-list-line',
        },
      },
      {
        path: 'gate',
        name: 'gateDevice',
        component: () => import('@/views/equipment_management/gate'),
        meta: {
          title: '闸机设备',
          icon: 'file-list-line',
        },
      },
      {
        path: 'buriedElectronicTireBreaker',
        name: 'tireBreakerDevice',
        component: () =>
          import('@/views/equipment_management/buried_electronic_tire_breaker'),
        meta: {
          title: '地埋式电控破胎器',
          icon: 'file-list-line',
        },
      },
      {
        path: 'bumpingPost',
        name: 'bumpingPostDevice',
        component: () => import('@/views/equipment_management/bumping_post'),
        meta: {
          title: '反恐拦截升降防撞柱',
          icon: 'file-list-line',
        },
      },
    ],
  },
  {
    path: '/blackWhiteList',
    name: 'blackWhiteList',
    component: Layout,
    redirect: '/blackWhiteList/carList',
    alwaysShow: true,
    meta: {
      title: '黑白名单',
      icon: 'vip-line',
    },
    children: [
      {
        path: 'carList',
        name: 'carList',
        component: () => import('@/views/black_white_list/car_list'),
        meta: {
          title: '车辆名单',
          icon: 'file-list-line',
        },
      },
      {
        path: 'carListApproval',
        name: 'carListApproval',
        component: () => import('@/views/black_white_list/car_list_approval'),
        meta: {
          title: '车辆名单审核',
          icon: 'list-check',
        },
      },
      {
        path: 'personList',
        name: 'personList',
        component: () => import('@/views/black_white_list/person_list'),
        meta: {
          title: '人员名单',
          icon: 'file-list-line',
        },
      },
      {
        path: 'personListApproval',
        name: 'personListApproval',
        component: () =>
          import('@/views/black_white_list/person_list_approval'),
        meta: {
          title: '人员名单审核',
          icon: 'list-check',
        },
      },
    ],
  },
  {
    path: '/notice',
    name: 'notice',
    component: Layout,
    redirect: '/notice/notice',
    alwaysShow: true,
    meta: {
      title: '通知管理',
      icon: 'file-info-line',
    },
    children: [
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/notice/notice'),
        meta: {
          title: '通知',
          icon: 'file-list-line',
        },
      },
    ]
  },
  {
    path: '/process',
    name: 'process',
    component: Layout,
    redirect: '/process/process',
    alwaysShow: true,
    meta: {
      title: '流程管理',
      icon: 'stackshare-line',
    },
    children: [
      {
        path: 'process',
        name: 'process',
        component: () => import('@/views/process/process'),
        meta: {
          title: '流程',
          icon: 'git-branch-line',
        },
      },
      {
        path: 'processNode',
        name: 'processNode',
        component: () => import('@/views/process/processNode'),
        meta: {
          title: '流程节点',
          icon: 'git-commit-line',
        },
      },
      {
        path: 'processDefinition',
        name: 'processDefinition',
        component: () => import('@/views/process/processDefinition'),
        meta: {
          title: '流程定义',
          icon: 'edit-line',
        },
      },
    ],
  },
  {
    path: '/system_manage',
    name: 'systemManage',
    component: Layout,
    redirect: '/system_manage/user',
    alwaysShow: true,
    meta: {
      title: '系统管理',
      icon: 'contacts-line',
    },
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/system_manage/user'),
        meta: {
          title: '用户',
          icon: 'account-box-line',
        },
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/system_manage/role'),
        meta: {
          title: '角色',
          icon: 'file-lock-line',
        },
      },
      {
        path: 'dept',
        name: 'dept',
        component: () => import('@/views/system_manage/dept'),
        meta: {
          title: '部门',
          icon: 'organization-chart',
        },
      },
      {
        path: 'perm',
        name: 'perm',
        component: () => import('@/views/system_manage/perm'),
        meta: {
          title: '权限',
          icon: 'file-lock-line',
        },
      },
      {
        path: 'modal',
        name: 'modal',
        component: () => import('@/views/system_manage/modal'),
        meta: {
          title: '车型',
          icon: 'file-list-line',
        },
      },
      {
        path: 'loginLog',
        name: 'loginLog',
        component: () => import('@/views/system_manage/login_log'),
        meta: {
          title: '登录日志',
          icon: 'file-history-line',
        },
      },
      {
        path: 'operationLog',
        name: 'operationLog',
        component: () => import('@/views/system_manage/operation_log'),
        meta: {
          title: '操作日志',
          icon: 'file-history-line',
        },
      },
    //   {
    //     path: '/userProfile',
    //     name: 'userProfile',
    //     component: () => import('@/views/system_manage/user_profile'),
    //     meta: {
    //       title: '个人中心',
    //       icon: 'stackshare-line',
    //       // affix: true,
    //     },
    //   },
    ],
  },
  {
    path: '/system_report',
    name: 'systemReport',
    component: Layout,
    redirect: '/system_report/vehicle_type_report',
    alwaysShow: true,
    meta: {
      title: '系统报表',
      icon: 'numbers-line',
    },
    children: [
      {
        path: 'person_reservation_count',
        name: 'personReservationCount',
        component: () =>
          import('@/views/system_report/person_reservation_count'),
        meta: {
          title: '人员预约单统计',
          icon: 'numbers-line',
        },
      },
      {
        path: 'person_count',
        name: 'personCount',
        component: () => import('@/views/system_report/person_count'),
        meta: {
          title: '人员出入园统计',
          icon: 'numbers-line',
        },
      },
      {
        path: 'person_depart_count',
        name: 'personDepartCount',
        component: () => import('@/views/system_report/person_depart_count'),
        meta: {
          title: '企业人员预约统计',
          icon: 'numbers-line',
        },
      },
      {
        path: 'vehicle_reservation',
        name: 'vehicleReservation',
        component: () => import('@/views/system_report/vehicle_reservation'),
        meta: {
          title: '车辆预约单统计',
          icon: 'numbers-line',
        },
      },
      {
        path: 'vehicle_type_count',
        name: 'vehicleTypeCount',
        component: () => import('@/views/system_report/vehicle_type_count'),
        meta: {
          title: '车型出入园统计',
          icon: 'numbers-line',
        },
      },
      {
        path: 'vehicle_gate_count',
        name: 'vehicleGateCount',
        component: () => import('@/views/system_report/vehicle_gate_count'),
        meta: {
          title: '车辆出入园统计',
          icon: 'numbers-line',
        },
      },
      {
        path: 'vehicle_increase',
        name: 'vehicleIncrease',
        component: () => import('@/views/system_report/vehicle_increase'),
        meta: {
          title: '每日车辆去重统计',
          icon: 'numbers-line',
        },
      },
      {
        path: 'vehicle_depart_count',
        name: 'vehicleDepartCount',
        component: () => import('@/views/system_report/vehicle_depart_count'),
        meta: {
          title: '企业车辆预约统计',
          icon: 'numbers-line',
        },
      },
      {
        path: 'approval_count',
        name: 'approvalCount',
        component: () => import('@/views/system_report/approval_count'),
        meta: {
          title: '审批统计',
          icon: 'numbers-line',
        },
      },
      // {
      //   path: 'application_count',
      //   name: 'applicationCount',
      //   component: () => import('@/views/system_report/application_count'),
      //   meta: {
      //     title: '申请单数量统计',
      //     icon: 'numbers-line',
      //   },
      // },
      {
        path: 'caar',
        name: 'caar',
        component: () => import('../views/system_report/car_application_approval_record'),
        meta: {
          title: '车辆预约审批记录',
          icon: 'numbers-line',
        },
      },
      {
        path: 'paar',
        name: 'paar',
        component: () => import('../views/system_report/person_application_approval_record'),
        meta: {
          title: '人员预约审批记录',
          icon: 'numbers-line',
        },
      },
      {
        path: 'vrar',
        name: 'vrar',
        component: () => import('@/views/system_report/vehicle_registration_approval_record'),
        meta: {
          title: '车辆备案审批记录',
          icon: 'numbers-line',
        },
      },
    ],
  },
  {
    path: '/gate_crossing_records',
    name: 'gate_crossing_records',
    component: Layout,
    redirect: '/gate_crossing_records/vehicle_gate_crossing_records',
    alwaysShow: true,
    meta: {
      title: '过闸记录',
      icon: 'menu-line',
    },
    children: [
      {
        path: 'vehicle_gate_crossing_records',
        name: 'vehicleGateCrosRecords',
        component: () =>
          import('@/views/gate_crossing_records/vehicle_gate_crossing_records'),
        meta: {
          title: '车辆过闸记录',
          icon: 'file-history-line',
        },
      },
      {
        path: 'person_gate_crossing_records',
        name: 'personGateCrosRecords',
        component: () =>
          import('@/views/gate_crossing_records/person_gate_crossing_records'),
        meta: {
          title: '人员过闸记录',
          icon: 'file-history-line',
        },
      },
    ],
  },
  {
    path: '/carRoute',
    name: 'carRoute',
    component: Layout,
    redirect: '/carRoute/carRoute',
    meta: {
      title: '车辆入园路线',
      icon: 'guide-line',
    },
    children: [
      {
        path: 'carRoute',
        name: 'carRoute',
        component: () => import('@/views/car_route'),
        meta: {
          title: '车辆入园路线管理',
          icon: 'guide-line',
        },
      },
    ],
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard'),
    hidden: true,
    meta: {
      title: '石化园区访客预约系统大屏',
      icon: 'car-line',
    },
  },
  {
    path: '/:pathMach(.*)*',
    redirect: '/404',
    hidden: true,
    noNeedAuth: true,
  },
]
const router = createRouter({
  history: createWebHistory(),
  // history: createWebHashHistory(),
  routes: constantRoutes,
})

export default router
